/* src/app/shared/components/message-modal/message-modal.component.scss */
.info {
  font-size: 0.9em;
  text-align: left;
  margin-top: 10px;
}
.info .icon {
  font-size: 2.5em;
  color: green;
  float: left;
  padding: 5px;
  margin-right: 10px;
}
/*# sourceMappingURL=message-modal.component-P7YYDJ7D.css.map */
